'use client';

import {
    generate as generateRichText,
    OFFICIAL_FONT_SIZE_KEY,
    showCutList as richTextShowCutList,
    createRichText,
} from './define';
import { RichText } from './RichText';

export {
    createRichText,
    generateRichText,
    RichText,
    OFFICIAL_FONT_SIZE_KEY,
    richTextShowCutList,
};
